import { Routes } from '@angular/router';

/**
 * Il frontend delle App (spec 004 research R-12): ogni App ha la sua cartella in `apps/` e una riga
 * qui. Le rotte si caricano solo quando si apre l'App. Il nome è quello predefinito: nel catalogo
 * vale quello del server, che l'operatore può cambiare.
 */
export interface AppRegistration {
  readonly code: string;
  readonly name: string;
  readonly loadRoutes: () => Promise<Routes>;
}

export const APP_REGISTRY: readonly AppRegistration[] = [
  {
    code: 'calcestruzzo',
    name: 'Calcestruzzo',
    loadRoutes: () =>
      import('./calcestruzzo/calcestruzzo.routes').then((module) => module.CALCESTRUZZO_ROUTES),
  },
];
